import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "aex-auth"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"aex-auth-background\" aria-hidden=\"true\"><i class=\"b b1\"></i><i class=\"b b2\"></i><i class=\"b b3\"></i><i class=\"b b4\"></i> <i class=\"rings\"></i><i class=\"rings r2\"></i><i class=\"sheen\"></i></div>", 1)
const _hoisted_3 = { class: "aex-auth__page" }
const _hoisted_4 = { class: "aex-auth__brand" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: "/aex/logo.png",
  alt: ""
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "AEX"),
  /*#__PURE__*/_createElementVNode("small", null, "Asset eXchange")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "aex-auth__tag" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "aex-auth__rail",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("i")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("From "),
    /*#__PURE__*/_createElementVNode("em", null, "Coins")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("to "),
    /*#__PURE__*/_createElementVNode("em", null, "Cash")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("with "),
    /*#__PURE__*/_createElementVNode("em", null, "Asset eXchange")
  ])
], -1)
const _hoisted_8 = { class: "aex-auth__form" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  class: "aex-auth__support",
  href: "mailto:info@aex.cx",
  "aria-label": "Написать в поддержку"
}, "✉", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AuthHeader = _resolveComponent("AuthHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AuthIntroduction = _resolveComponent("AuthIntroduction")!

  return (_ctx.isAex)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            class: "aex-auth__back",
            to: "/landing"
          }, {
            default: _withCtx(() => [
              _createTextVNode("← На главную")
            ]),
            _: 1
          }),
          _createVNode(_component_AuthHeader, { class: "aex-auth__header" }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              class: "aex-auth__logo",
              to: "/landing",
              "aria-label": "AEX"
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _hoisted_6
              ]),
              _: 1
            }),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_router_view)
          ])
        ]),
        _hoisted_9
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(_ctx.b())
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('container'))
        }, [
          _createVNode(_component_AuthHeader),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('content'))
          }, [
            _createVNode(_component_AuthIntroduction, {
              class: _normalizeClass(_ctx.b('introduction'))
            }, null, 8, ["class"]),
            _createVNode(_component_router_view)
          ], 2)
        ], 2)
      ], 2))
}